<template>
  <svg
    width="20"
    height="20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  ><g
    clip-path="url(#a)"
    stroke="currentColor"
    stroke-width="1.25"
    stroke-linecap="round"
    stroke-linejoin="round"
  ><path d="M12.397 12.519c.337-.043.652-.19.9-.424a1.602 1.602 0 0 1 2.196 0 1.604 1.604 0 0 0 2.198 0l1.098-1.034M1.21 11.06l1.1 1.035a1.605 1.605 0 0 0 2.197 0 1.601 1.601 0 0 1 2.197 0" /><path d="M2.773 8.9h14.454s1.562 0 1.562 1.562v6.463s0 1.563-1.562 1.563H2.773s-1.562 0-1.562-1.563v-6.463s0-1.563 1.562-1.563Z" /><path d="M10.764 12H9.16L9 13.764l.37-.185c.179-.09.375-.136.574-.136h.018c.532 0 .963.431.963.963v.48c0 .532-.431.963-.963.963-.419 0-.83-.268-.962-.641M3.99 4.904h.834a.781.781 0 0 1 .781.781V8.9H3.208V5.685a.781.781 0 0 1 .782-.781ZM9.583 4.904h.834a.781.781 0 0 1 .781.781V8.9H8.802V5.685a.781.781 0 0 1 .78-.781ZM15.176 4.904h.834a.781.781 0 0 1 .781.781V8.9h-2.396V5.685a.781.781 0 0 1 .78-.781ZM4.407 2.711V1.513M10 2.711V1.513M15.593 2.711V1.513" /></g><defs><clipPath id="a"><path
    fill="#fff"
    d="M0 0h20v20H0z"
  /></clipPath></defs></svg>
</template>
